<template lang="pug">
#visualizar-operacao
    div(v-show='mostrarVisualizarOperacao')
        BaseHeader(
            :titulo='$t("mensagens.operacao.visualizar.titulo")',
            :voltarPara='true',
            :exibeBotao='false'
        )
            template(slot='direita')
                el-dropdown(trigger='click')
                    BaseButton.visualizar-operacao__header__acao__botao(
                        type='primary'
                    )
                        i.el-icon-arrow-down
                        span {{ $t('mensagens.operacao.tabela.acoes') }}

                    el-dropdown-menu(slot='dropdown')
                        el-dropdown-item(
                            v-for='(acoes, index) in acoesOperacao',
                            :key='index',
                            :icon='operacaoStatusAcoes[acoes].icone',
                            @click.native='operacaoStatusAcoes[acoes].callback(acoes)'
                        ) {{ operacaoStatusAcoes[acoes].nome }}

        .view-container-base-header
            .titulo-card(v-if='exibirAnalise')
                span {{ $t('mensagens.operacao.visualizar.analiseOperacao') }}
            .visualizar-operacao__card(v-if='exibirAnalise')
                card
                    .row.data-display.visualizar-operacao__card__historico
                        i.el-icon-time.visualizar-operacao__card__historico--icone(
                            @click='visualizarHistorico()'
                        )
                            span.visualizar-operacao__card__historico--icone-texto {{ $t('mensagens.operacao.visualizar.historico.icone') }}
                    .row
                        .col-12.data-display
                            .visualizar-operacao__card__status.row(
                                :style='"background:" + analiseOperacao[analise.codigo].cor'
                            )
                                .col-1.p-0(style='height: 100%')
                                    .visualizar-operacao__card__status--icone(
                                        :style='"background:" + analiseOperacao[analise.codigo].corFundoIcone'
                                    )
                                        .d-flex.justify-content-center.align-items-center
                                            .visualizar-operacao__card__status--icone--backbround
                                            i(
                                                :class='analiseOperacao[analise.codigo].icone',
                                                :style='"color:" + analiseOperacao[analise.codigo].corIcone'
                                            )
                                .col-11.text-justify
                                    div {{ $t(`mensagens.operacao.${analise.codigo}`) }}

                    .row
                        .col-4.data-display
                            span.data-title
                                | {{ $t('mensagens.operacao.visualizar.responsavelCadastro') }}
                            span.data-value
                                | {{ analise.responsavelCadastro || '--' }}
                        .col-4.data-display
                            span.data-title
                                | {{ $t('mensagens.operacao.visualizar.dataCadastro') }}
                            span.data-value
                                | {{ analise.dataCadastro || '--' }}
                        .col-4.data-display
                            span.data-title
                                | {{ $t('mensagens.operacao.visualizar.empresa') }}
                            span.data-value
                                | {{ analise.empresaCadastro || '--' }}

                    .row(
                            v-if='analise.codigo === "APROVADO" || analise.codigo === "REPROVADO" || (analise.codigo === "CANCELADO" && analise.dataAprovacaoReprovacao)'
                        )
                        .col-4.data-display
                            span.data-title
                                | {{ $t('mensagens.operacao.visualizar.responsavelAnalise') }}
                            span.data-value
                                | {{ analise.responsavelAprovacaoReprovacao || '--' }}
                        .col-4.data-display
                            span.data-title
                                | {{ $t('mensagens.operacao.visualizar.dataAnalise') }}
                            span.data-value
                                | {{ analise.dataAprovacaoReprovacao || '--' }}
                        .col-4.data-display
                            span.data-title
                                | {{ $t('mensagens.operacao.visualizar.empresa') }}
                            span.data-value
                                | {{ analise.empresaAprovacaoReprovacao || '--' }}

                    .row(
                            v-if='analise.codigo === "CANCELADO"'
                        )
                        .col-4.data-display
                            span.data-title
                                | {{ $t('mensagens.operacao.visualizar.responsavelCancelamento') }}
                            span.data-value
                                | {{ analise.responsavelCancelamento || '--' }}
                        .col-4.data-display
                            span.data-title
                                | {{ $t('mensagens.operacao.visualizar.dataCancelamento') }}
                            span.data-value
                                | {{ analise.dataCancelamento || '--' }}
                        .col-4.data-display
                            span.data-title
                                | {{ $t('mensagens.operacao.visualizar.empresa') }}
                            span.data-value
                                | {{ analise.empresaCancelamento || '--' }}

                    .row(
                        v-if='analise.codigo === "REPROVADO" || analise.codigo === "CANCELADO"'
                    )
                        .data-display(
                            :class='analise.codigo === "REPROVADO" ? "col-6" : "col-12"'
                        )
                            span.data-title
                                | {{ $t('mensagens.operacao.justificativa') }}
                            span.data-value
                                | {{ analise.justificativa || '--' }}
                        .col-6.data-display(
                            v-if='analise.codigo === "REPROVADO"'
                        )
                            span.data-title
                                | {{ $t('mensagens.operacao.visualizar.motivos') }}
                            span.data-value(style='overflow: auto')
                                | {{ dadosGerais.motivosReprovacao }}

                    .row(v-if='analise.possuiPrimeiraAnalise === true || analise.codigo ==="APROVADO"')
                        .col-12.data-display
                            div
                                span.data-value
                                    | {{ $t('mensagens.operacao.monitoramento.revisarAnaliseTexto1') }}&nbsp;
                                BaseButton.button-link(
                                    type='text',
                                    @click='downloadPrimeiraAnalise()'
                                ) {{ $t('mensagens.operacao.monitoramento.revisarAnaliseTexto2') }}

                    .row(v-if='analise.mostrarElegibilidadeBonusCar === true')
                        .col-12.data-display
                            .visualizar-operacao__card__status.row(
                                :style='"background:" + analiseOperacaoBonusCar[analise.elegivelBonusCar].cor'
                            )
                                .col-1.p-0(style='height: 100%')
                                    .visualizar-operacao__card__status--icone(
                                        :style='"background:" + analiseOperacaoBonusCar[analise.elegivelBonusCar].corFundoIcone'
                                    )
                                        .d-flex.justify-content-center.align-items-center
                                            .visualizar-operacao__card__status--icone--backbround
                                            i(
                                                :class='analiseOperacaoBonusCar[analise.elegivelBonusCar].icone',
                                                :style='"color:" + analiseOperacaoBonusCar[analise.elegivelBonusCar].corIcone'
                                            )
                                .col-11.text-justify
                                    div {{ analiseOperacaoBonusCar[analise.elegivelBonusCar].titulo}}

            .titulo-card(v-if='dadosGerais')
                span {{ $t('mensagens.operacao.cadastrarEditarOperacao.dadosGerais') }}
            .visualizar-operacao__card(v-if='dadosGerais')
                card
                    .row
                        .col-3.data-display
                            span.data-title
                                | {{ $t('mensagens.operacao.tabela.nome') }}
                            span.data-value
                                | {{ dadosGerais.nome ? dadosGerais.nome : '--' }}

                        .col-3.data-display
                            span.data-title
                                | {{ $t('mensagens.operacao.tabela.categoria') }}
                            span.data-value
                                | {{ this.dadosGerais.categoria.nome ? this.dadosGerais.categoria.nome : '--' }}

                        .col-3.data-display
                            span.data-title
                                | {{ $t('mensagens.operacao.tabela.numContrato') }}
                            span.data-value
                                | {{ dadosGerais.numeroContrato ? dadosGerais.numeroContrato : '--' }}

                        .col-3.data-display
                            span.data-title
                                | {{ $t('mensagens.operacao.formularioGeral.identificadorOperacao') }}
                            span.data-value(style='word-break: break-all')
                                | {{ dadosGerais.identificadorOperacao ? dadosGerais.identificadorOperacao : '--' }}
                    .row
                        .col-3.data-display
                            span.data-title
                                | {{ $t('mensagens.operacao.formularioGeral.dataContratacao') }}
                            span.data-value
                                | {{ dadosGerais.dataContratacaoFormatado ? dadosGerais.dataContratacaoFormatado : '--' }}
                        .col-3.data-display
                            span.data-title
                                | {{ $t('mensagens.operacao.formularioGeral.dataLiberacao') }}
                            span.data-value
                                | {{ dadosGerais.dataLiberacaoFormatado ? dadosGerais.dataLiberacaoFormatado : '--' }}
                        .col-3.data-display
                            span.data-title
                                | {{ $t('mensagens.operacao.tabela.vigencia') }}
                            span.data-value
                                | {{ dadosGerais.vigenciaFormatado ? dadosGerais.vigenciaFormatado : '--' }}
                        .col-3.data-display
                            span.data-title
                                | {{ $t('mensagens.operacao.formularioGeral.valorTotalOperacao') }}:
                            span.data-value
                                | {{ formatarValorTotalOperacao(dadosGerais.valorTotalOperacao) }}
                    .row
                        .col-12.data-display
                            span.data-title
                                | {{ $t('mensagens.operacao.formularioGeral.descricao') }}
                            span.data-value
                                | {{ dadosGerais.descricao ? dadosGerais.descricao : '--' }}

            .titulo-card(v-if='atividades')
                span {{ $t('mensagens.operacao.atividades') }}
            .visualizar-operacao__card(v-if='atividades')
                card
                    span.titulo {{ $t('mensagens.operacao.formularioAtividade.atividadesAdicionadas') }}
                    el-table(:data='atividades', style='padding-bottom: 10px')
                        el-table-column(
                            :label='$t("mensagens.operacao.formularioAtividade.tipo")'
                        )
                            template(slot-scope='scope')
                                span
                                    | {{ scope.row.tipo === 'agrícola' ? $t('mensagens.operacao.formularioAtividade.agricola') : $t('mensagens.operacao.formularioAtividade.pecuaria') }}
                        el-table-column(
                            :label='$t("mensagens.operacao.formularioAtividade.produto")'
                        )
                            template(slot-scope='scope')
                                span(style='word-break: keep-all')
                                    | {{ scope.row.nomeProduto }}
                        el-table-column(
                            :label='$t("mensagens.operacao.formularioAtividade.areaFinanciadaHa")'
                        )
                            template(slot-scope='scope')
                                money.remove-estilos(
                                    v-model='scope.row.areaFinanciada',
                                    v-bind='areaMask',
                                    readonly
                                )
                        el-table-column(
                            :label='$t("mensagens.operacao.formularioAtividade.quantidade")'
                        )
                            template(slot-scope='scope')
                                span
                                    | {{ scope.row.tipo === 'pecuária' && scope.row.quantidade && scope.row.quantidade !== 0 ? scope.row.quantidade.toString().replace('.', ',') : '--' }}
                        el-table-column(
                            :label='$t("mensagens.operacao.formularioAtividade.inicioPlantio")'
                        )
                            template(slot-scope='scope')
                                span
                                    | {{ scope.row.tipo === 'agrícola' ? scope.row.inicioPlantioFormatado : '--' }}
                        el-table-column(
                            :label='$t("mensagens.operacao.formularioAtividade.fimPlantio")'
                        )
                            template(slot-scope='scope')
                                span
                                    | {{ scope.row.tipo === 'agrícola' ? scope.row.fimPlantioFormatado : '--' }}
                        el-table-column(
                            :label='$t("mensagens.operacao.formularioAtividade.inicioColheita")'
                        )
                            template(slot-scope='scope')
                                span
                                    | {{ scope.row.tipo === 'agrícola' ? scope.row.inicioColheitaFormatado : '--' }}
                        el-table-column(
                            :label='$t("mensagens.operacao.formularioAtividade.fimColheita")'
                        )
                            template(slot-scope='scope')
                                span
                                    | {{ scope.row.tipo === 'agrícola' ? scope.row.fimColheitaFormatado : '--' }}

            .titulo-card(v-if='pessoasGrupoEconomico')
                span {{ $t('mensagens.operacao.cadastrarEditarOperacao.pessoaGrupoEconomico') }}
            .visualizar-operacao__card(v-if='pessoasGrupoEconomico')
                card
                    span.titulo {{ $t('mensagens.operacao.formularioPessoa.pessoasAdicionadas') }}
                    el-table(:data='pessoasGrupoEconomico')
                        el-table-column(
                            :label='$t("mensagens.operacao.tabela.nomeRazaoSocial")'
                        )
                            template(slot-scope='scope')
                                span
                                    | {{ scope.row.pessoa.nomeRazaoSocial }}
                        el-table-column(
                            :label='$t("mensagens.operacao.tabela.documento")'
                        )
                            template(slot-scope='scope')
                                span
                                    | {{ numeralStringFormatTocpfCnpj(scope.row.pessoa.cpfCnpj) }}
                        el-table-column(
                            :label='$t("mensagens.operacao.formularioPessoa.papel")'
                        )
                            template(slot-scope='scope')
                                span
                                    | {{ scope.row.papel.nome }}
                        el-table-column(
                            :label='$t("mensagens.operacao.tabela.restricaoSocio")',
                            align='center'
                        )
                            template(slot-scope='scope')
                                BaseButton.remove-estilos(
                                    :loading='loadingDiagnostico'
                                )
                                div(v-if='!loadingDiagnostico')
                                    i.mr-2.flow.flow-verified.verde.mr8.custon-icon(
                                        v-if='scope.row.pessoa.restricao === "Não"'
                                    )
                                    i.mr-2.flow.flow-warning-sign.vermelho.mr8.custon-icon(
                                        v-else-if='scope.row.pessoa.restricao === "Sim"'
                                    )
                                    span(v-if='scope.row.pessoa.restricao') {{ scope.row.pessoa.restricao }}
                                    el-tooltip(
                                        v-if='scope.row.pessoa.resultado',
                                        :content='$t("mensagens.operacao.formularioPessoa.visualizarResultado")',
                                        placement='bottom-end',
                                        effect='light'
                                    )
                                        i.el-icon-view.icon-view(
                                            @click='visualizarDiagnostico(scope.row)'
                                        )

            .titulo-card(v-if='operacao')
                span {{ $t('mensagens.operacao.cadastrarEditarOperacao.territorioGleba') }}
            .visualizar-operacao__card(v-if='operacao')
                FormularioTerritorioGlebaOperacao(
                    :dadosVisualizacao='operacao'
                )

    ModalResultadoDiagnosticoPessoa(
        confirmar,
        :mostrar='mostrarModalDiagnosticoPessoa',
        :pessoa='pessoaSelecionada',
        @fechar='mostrarModalDiagnosticoPessoa = false'
    )

    CardAnaliseSocioambientalOperacao(
        v-if='mostrarCardAnaliseSocioambiental',
        :habilitar-botao-cadastrar='false',
        :dadosDiagnostico='dadosAnaliseSocioambientalProtocolo',
        @fechar='fecharCardAnaliseSocioambientalOperacao'
    )

    ModalVisualizarHistorico(
        :idOperacao='idOperacao'
        :mostrar='mostrarModalVisualizarHistorico'
        @fechar='mostrarModalVisualizarHistorico = false'
    )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import CardAnaliseSocioambientalOperacao from '@/components/operacao/gestao/CardAnaliseSocioambientalOperacao.vue';
import DiagnosticoSocioambientalProtocoloService from '@/services/DiagnosticoSocioambientalProtocoloService';
import OperacaoService from '@/services/OperacaoService';
import Card from '@/components/Card';
import { Money } from 'v-money';
import formatters from '@/utils/formatters';
import ModalResultadoDiagnosticoPessoa from '@/components/operacao/gestao/ModalResultadoDiagnosticoPessoaOperacao.vue';
import ModalVisualizarHistorico from '@/components/operacao/gestao/ModalVisualizarHistorico.vue';
import FormularioTerritorioGlebaOperacao from '@/components/operacao/gestao/FormularioTerritorioGlebaOperacao.vue';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
import { mapGetters } from 'vuex';
import operacaoMixin from '@/mixins/OperacaoMixin';

export default {
    name: 'VisualizarOperacao',

    components: {
        BaseHeader,
        Card,
        Money,
        ModalResultadoDiagnosticoPessoa,
        ModalVisualizarHistorico,
        FormularioTerritorioGlebaOperacao,
        CardAnaliseSocioambientalOperacao,
        BaseButton
    },
    
    mixins: [operacaoMixin],

    data() {
        return {
            operacao: null,
            idOperacao: this.$route.params.id,
            acoesOperacao: [
                'REALIZAR_ANALISE_SOCIOAMBIENTAL'
            ],
            analise: null,
            dadosGerais: null,
            atividades: null,
            nomeCategoria: null,
            pessoasGrupoEconomico: null,
            mostrarModalVisualizarHistorico: false,
            operacaoStatusAcoes: {
                REALIZAR_ANALISE_SOCIOAMBIENTAL: {
                    nome: this.$t('mensagens.operacao.acoes.realizarAnalise'),
                    icone: 'flow flow-environment',
                    callback: this.realizarAnaliseSocioambiental
                },
                GERAR_ARQUIVO_XLSX: {
                    nome: this.$t('mensagens.operacao.acoes.xlsx'),
                    icone: 'el-icon-download',
                    callback: this.gerarArquivoCoordenadasXLSX
                },
                GERAR_ARQUIVO_BNDES_XLSX: {
                    nome: this.$t('mensagens.operacao.acoes.xlsxBNDES'),
                    icone: 'el-icon-download',
                    callback: this.gerarArquivoCoordenadasXLSXBndes
                },
                EXPORTAR_ANALISE: {
                    nome: this.$t('mensagens.operacao.acoes.exportaAnalise'),
                    codigo: 'EXPORTAR_ANALISE',
                    icone: 'el-icon-picture-outline',
                    callback: this.exportarAnaliseSocioambiental
                },
                VISUALIZAR_MONITORAMENTO: {
                    nome: this.$t('mensagens.operacao.acoes.monitoramento'),
                    codigo: 'VISUALIZAR_MONITORAMENTO',
                    icone: 'el-icon-monitor',
                    callback: this.visualizarMonitoramento
                }
            },
            analiseOperacao: {
                EM_ANALISE: {
                    cor: '#F8834233',
                    corIcone: 'var(--warning)',
                    corFundoIcone: '#F8834266',
                    icone: 'mdi mdi-clock-time-five',
                    titulo: this.$t(
                        'mensagens.operacao.visualizar.operacaoAnalise'
                    )
                },
                EM_PROCESSAMENTO: {
                    cor: '#F8834233',
                    corIcone: 'var(--warning)',
                    corFundoIcone: '#F8834266',
                    icone: 'mdi mdi-clock-time-five',
                    titulo: this.$t(
                        'mensagens.operacao.visualizar.operacaoProcessamento'
                    )
                },
                AGUARDANDO_APROVACAO: {
                    cor: 'var(--operation-awaiting-approval)',
                    corIcone: '#626466',
                    corFundoIcone: 'var(--background-disabled)',
                    icone: 'mdi mdi-clock-time-five',
                    titulo: this.$t(
                        'mensagens.operacao.visualizar.operacaoAguardaAprovacao'
                    )
                },
                APROVADO: {
                    cor: 'var(--approved-operation)',
                    corIcone: 'var(--secondary-two)',
                    corFundoIcone: 'var(--secondary)',
                    icone: 'mdi mdi-checkbox-marked-circle',
                    titulo: this.$t(
                        'mensagens.operacao.visualizar.operacaoAprovada'
                    )
                },
                REPROVADO: {
                    cor: 'var(--disapproved-operation)',
                    corIcone: 'var(--font-danger)',
                    corFundoIcone: '#DF675B',
                    icone: 'mdi mdi-close-circle',
                    titulo: this.$t(
                        'mensagens.operacao.visualizar.operacaoReprovada'
                    )
                },
                VENCIDO: {
                    cor: 'var(--disapproved-operation)',
                    corIcone: 'var(--font-danger)',
                    corFundoIcone: '#DF675B',
                    icone: 'mdi mdi-close-circle',
                    titulo: this.$t('mensagens.operacao.visualizar.operacaoVencida')
                },
                CANCELADO: {
                    cor: 'var(--disapproved-operation)',
                    corIcone: 'var(--font-danger)',
                    corFundoIcone: '#DF675B',
                    icone: 'mdi mdi-close-circle',
                    titulo: this.$t('mensagens.operacao.visualizar.operacaoVencida')
                }
            },
            analiseOperacaoBonusCar: {
                true: {
                    cor: 'var(--approved-operation)',
                    corIcone: 'var(--secondary-two)',
                    corFundoIcone: 'var(--secondary)',
                    icone: 'mdi mdi-checkbox-marked-circle',
                    titulo: this.$t(
                        'mensagens.operacao.visualizar.elegivelBonusCar'
                    )
                },

                false: {
                    cor: 'var(--disapproved-operation)',
                    corIcone: 'var(--font-danger)',
                    corFundoIcone: '#DF675B',
                    icone: 'mdi mdi-close-circle',
                    titulo: this.$t(
                        'mensagens.operacao.visualizar.naoElegivelBonusCar'
                    )
                }
            },

            moneyMask: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            areaMask: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false
            },
            mostrarModalDiagnosticoPessoa: false,
            pessoaSelecionada: {},
            loadingDiagnostico: true,
            exibirAnalise: false,
            dadosAnaliseSocioambientalProtocolo: {
                pessoas: [],
                territorios: [],
                idOperacao: null
            },
            mostrarVisualizarOperacao: true,
            mostrarCardAnaliseSocioambiental: false
        };
    },

    computed: {
        ...mapGetters(['usuarioLogado'])
    },

    async created() {
        this.verificarParametroRota();
        await this.fetchOperacao();
        this.habilitarOpcoesMenuAcaoPorPermissaoUsuario();
    },

    methods: {
        habilitarOpcoesMenuAcaoPorPermissaoUsuario() {
            if (this.analise.codigo !== 'EM_PROCESSAMENTO') {
                this.acoesOperacao.push('EXPORTAR_ANALISE');
            }
            
            if (
                this.usuarioLogado.operacaoAprovador &&
                this.analise.codigo === 'APROVADO'
            ) {
                const possiveisAcoes = [
                    'GERAR_ARQUIVO_XLSX',
                    'GERAR_ARQUIVO_BNDES_XLSX',
                    'VISUALIZAR_MONITORAMENTO'
                ];

                const acoesParaAdicionar = possiveisAcoes.filter(acao =>
                    this.acoes.includes(acao)
                );

                this.acoesOperacao.push(...acoesParaAdicionar);
            }
        },

        realizarAnaliseSocioambiental() {
            const atividades =
                this.dadosAnaliseSocioambientalProtocolo.atividades ??
                this.operacao?.atividades;

            this.dadosAnaliseSocioambientalProtocolo = {
                pessoas: [],
                territorios: [],
                idCategoria: this.operacao.dadosGerais.categoria.id,
                idOperacao: this.$route.params.id
            };

            this.pessoasGrupoEconomico
                .map(e => e.pessoa)
                .forEach(pessoa => {
                    this.dadosAnaliseSocioambientalProtocolo.pessoas.push({
                        cpfCnpj: pessoa.cpfCnpj,
                        nomeRazaoSocial: pessoa.nomeRazaoSocial
                    });
                });

            this.operacao.territoriosGlebas.forEach(territorio => {
                const glebas = territorio.glebas.map(gleba => {
                    return {
                        utilizouAreaTotalTerritorio:
                            territorio.utilizouAreaTotalTerritorio,
                        geometria: gleba.geometria,
                        nome: gleba.operacaoIdentificadorGleba,
                        idTipo: gleba.tipo.id,
                        areaHa: gleba.area
                    };
                });

                this.dadosAnaliseSocioambientalProtocolo.territorios.push({
                    idTerritorio: territorio.id,
                    glebas,
                    geometria: territorio.geometria,
                    visualizarOperacao: true,
                    nomeTerritorio: territorio.nome
                });
            });

            this.dadosAnaliseSocioambientalProtocolo = {
                ...this.dadosAnaliseSocioambientalProtocolo,
                atividades,
                idOperacao: this.$route.params.id
            };
            
            this.mostrarVisualizarOperacao = false;
            this.mostrarCardAnaliseSocioambiental = true;
        },
        fecharCardAnaliseSocioambientalOperacao() {
            this.mostrarVisualizarOperacao = true;
            this.mostrarCardAnaliseSocioambiental = false;
        },

        async gerarArquivoCoordenadasXLSX() {
            try {
                await OperacaoService.baixarCoordenadasExcel(this.idOperacao);

                this.$notify.success({
                    message: this.$t(
                        'mensagens.operacao.notificacao.downloadRealizado'
                    )
                });
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.operacao.notificacao.downloadErro'
                    )
                });
            }
        },

        async gerarArquivoCoordenadasXLSXBndes() {
            try {
                await OperacaoService.baixarCoordenadasExcelBndes(
                    this.idOperacao
                );

                this.$notify.success({
                    message: this.$t(
                        'mensagens.operacao.notificacao.downloadRealizado'
                    )
                });
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.operacao.notificacao.downloadErro'
                    )
                });
            }
        },

        async exportarAnaliseSocioambiental() {
            try {
                await OperacaoService.exportarAnalise(this.idOperacao);
                this.$notify.success({
                    message: this.$t(
                        'mensagens.operacao.notificacao.analiseExportada'
                    ),
                    span: this.idOperacao
                });
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.operacao.notificacao.analiseErro'
                    )
                });
            }
        },

        async downloadPrimeiraAnalise() {
            try {
                await OperacaoService.downloadPrimeiraAnalise(this.idOperacao);
                this.$notify.success({
                    message: this.$t(
                        'mensagens.operacao.notificacao.downloadRealizado'
                    )
                });
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.operacao.notificacao.downloadAnaliseErro'
                    )
                });
            }
        },

        visualizarMonitoramento() {
            this.$router.push({
                name: 'operacaoMonitoramento',
                params: { id: this.idOperacao }
            });
        },

        visualizarDiagnostico(pessoa) {
            this.pessoaSelecionada = pessoa.pessoa;
            this.mostrarModalDiagnosticoPessoa = true;
        },

        visualizarHistorico() {
            this.mostrarModalVisualizarHistorico = true;
        },

        async realizarDiagnosticos() {
            if (this.pessoasGrupoEconomico) {
                for (const [
                    index,
                    pessoaGrupoEconomico
                ] of this.pessoasGrupoEconomico.entries()) {
                    try {
                        if (
                            pessoaGrupoEconomico.pessoa.resultado !== undefined
                        ) {
                            this.verificarLoadingPessoas(index);
                            return;
                        }
                        const { data } =
                            await DiagnosticoSocioambientalProtocoloService.consultar(
                                'CPF_CNPJ',
                                pessoaGrupoEconomico.pessoa.cpfCnpj,
                                this.idOperacao
                            );
                        pessoaGrupoEconomico.pessoa.resultado =
                            data.diagnostico;

                        const restricao =
                            pessoaGrupoEconomico.pessoa.resultado.filter(
                                d => d.resultados.length > 0
                            );

                        if (restricao.length > 0) {
                            pessoaGrupoEconomico.pessoa.restricao = 'Sim';
                        } else {
                            pessoaGrupoEconomico.pessoa.restricao = 'Não';
                        }

                        pessoaGrupoEconomico.pessoa.diagnostico = {
                            diagnostico: pessoaGrupoEconomico.pessoa.resultado
                        };

                        this.verificarLoadingPessoas(index);

                        const pessoaDuplicada =
                            this.pessoasGrupoEconomico.findIndex(
                                item =>
                                    item.pessoa.cpfCnpj ===
                                        pessoaGrupoEconomico.pessoa.cpfCnpj &&
                                    item.pessoa.resultado !== undefined
                            );
                        if (pessoaDuplicada >= 0) {
                            this.pessoasGrupoEconomico[
                                pessoaDuplicada
                            ].pessoa.resultado = data.diagnostico;
                            this.pessoasGrupoEconomico[
                                pessoaDuplicada
                            ].pessoa.restricao =
                                pessoaGrupoEconomico.pessoa.restricao;
                        }
                    } catch (error) {
                        pessoaGrupoEconomico.pessoa.diagnostico = null;
                        pessoaGrupoEconomico.pessoa.restricao = '--';

                        this.$notify.error({
                            message: this.$t(
                                'mensagens.operacao.notificacao.erroDiagnosticoSocio'
                            )
                        });
                    }
                }
            }
        },

        verificarLoadingPessoas(index) {
            if (this.pessoasGrupoEconomico.length - 1 === index) {
                setTimeout(() => {
                    this.loadingDiagnostico = false;
                }, 500);
            }
        },

        async fetchOperacao() {
            try {
                const { data } = await OperacaoService.buscarPorId(
                    this.idOperacao
                );
                this.operacao = data;
                this.analise = data.analise;
                this.pessoasGrupoEconomico = data.pessoasGrupoEconomico;
                this.dadosGerais = data.dadosGerais;
                this.atividades = data.atividades;
                this.idOperacao = data.dadosGerais.id;
                this.acoes = data.acoes || [];
                this.realizarDiagnosticos();

                if (this.analise !== null) {
                    this.exibirAnalise = true;
                }
            } catch (error) {
                if (error.response) {
                    this.$notify.error({
                        message: error.response.data.message
                    });
                } else {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.operacao.notificacao.naoBuscouOperacao'
                        )
                    });
                }

                this.$router.back();
            }
        },

        numeralStringFormatTocpfCnpj(cpfCnpj) {
            return formatters.numeralStringFormatToDocumento(cpfCnpj);
        },
        formatarValorTotalOperacao(valor) {
            if (valor) {
                return `R$ ${formatters.formatNumber(valor, 2)}`;
            }
            return 'R$ 0,00';
        },
        verificarParametroRota() {
            if (
                this.$route.params.id === undefined ||
                this.$route.params.id === null
            ) {
                this.router.push({ name: 'operacao' });
            }
        }
    }
};
</script>

<style lang="scss">
#visualizar-operacao {
    .visualizar-operacao__header__acao__botao {
        color: var(--white);
        background: var(--primary);
        border-color: var(--primary);
        border-radius: $default-border-radius;
        font-weight: map-get($font-weight, normal);
        padding: 12px 20px;
        font-size: 14px;
    }

    .visualizar-operacao__card {
        margin-bottom: 20px;
    }

    .visualizar-operacao__card__historico {
        text-align: right;
        vertical-align: middle;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        color: var(--primary);

        .visualizar-operacao__card__historico--icone {
            cursor: pointer;
            font-size: 17px;
        }

        .visualizar-operacao__card__historico--icone-texto {
            margin-left: 2px;
            font-family: "Roboto", sans-serif !important;
            font-size: 15px;
        }
    }

    .visualizar-operacao__card__status {
        height: 55px;
        background-color: var(--milho-color);
        border-radius: $default-border-radius;
        justify-items: center;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-weight: 600;
        margin: 0;

        .visualizar-operacao__card__status--icone {
            font-size: 30px;
            display: flex;
            justify-content: center;
            width: 60px;
            height: 100%;
            border-radius: 4px 0 0 4px;

            .visualizar-operacao__card__status--icone--backbround {
                background-color: var(--white);
                z-index: 0;
                height: 15px;
                width: 15px;
                position: absolute;
            }
        }
    }

    .data-display {
        display: flex;
        flex-direction: column;
        padding: 15px 20px;

        .data-title {
            font-size: 14px;
            margin-bottom: 15px;
            color: var(--primary);
        }

        .data-value {
            font-size: 14px;
            color: #636363;
        }
    }

    .remove-estilos {
        all: unset;
        caret-color: transparent;
    }

    .voltar {
        cursor: pointer;
        margin-right: 10px;
    }

    .icon-view {
        font-size: 20px;
        cursor: pointer;
        padding-left: 18px;
    }

    .titulo {
        font-size: 14px;
        font-weight: 600;
        color: dimgray;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .el-table th {
        font-size: 15px;
        color: var(--primary);
        font-weight: map-get($font-weight, normal);
    }

    .mdi {
        z-index: 1;
    }

    .button-link {
        color: #1e90ff;
        text-decoration: underline;
    }

    .titulo-card {
        font-size: 16px;
        font-weight: 600;
        padding-bottom: 7px;
    }
}
</style>
